function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Layout, Avatar, Popover, Button } from '@nackle/paper';
var Header = Layout.Header;
import CompanySelect from '../company-select/company-select.js';
import './app-header.less';

var AppHeader = /*#__PURE__*/function (_Component) {
  _inherits(AppHeader, _Component);

  var _super = _createSuper(AppHeader);

  function AppHeader() {
    var _this;

    _classCallCheck(this, AppHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderUserMenuTitle", function () {
      var _auth$state, _auth$state$claims, _auth$state2, _auth$state2$claims, _auth$state3, _auth$state3$claims;

      var auth = _this.props.auth;
      return /*#__PURE__*/React.createElement("div", {
        className: "app-header-profile"
      }, /*#__PURE__*/React.createElement(Avatar, {
        src: auth === null || auth === void 0 ? void 0 : (_auth$state = auth.state) === null || _auth$state === void 0 ? void 0 : (_auth$state$claims = _auth$state.claims) === null || _auth$state$claims === void 0 ? void 0 : _auth$state$claims.picture,
        size: 64
      }, _this.getInitials()), /*#__PURE__*/React.createElement("span", {
        className: "name"
      }, auth === null || auth === void 0 ? void 0 : (_auth$state2 = auth.state) === null || _auth$state2 === void 0 ? void 0 : (_auth$state2$claims = _auth$state2.claims) === null || _auth$state2$claims === void 0 ? void 0 : _auth$state2$claims.name), /*#__PURE__*/React.createElement("span", {
        className: "username"
      }, auth === null || auth === void 0 ? void 0 : (_auth$state3 = auth.state) === null || _auth$state3 === void 0 ? void 0 : (_auth$state3$claims = _auth$state3.claims) === null || _auth$state3$claims === void 0 ? void 0 : _auth$state3$claims.username));
    });

    _defineProperty(_assertThisInitialized(_this), "renderUserMenuContent", function () {
      var auth = _this.props.auth;
      return /*#__PURE__*/React.createElement("div", {
        className: "app-header-user-menu"
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-container"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "primary",
        ghost: true,
        onClick: auth.signOut
      }, /*#__PURE__*/React.createElement("span", null, "Sign out"))));
    });

    _defineProperty(_assertThisInitialized(_this), "getInitials", function () {
      var _auth$state4, _auth$state4$claims, _auth$state5, _auth$state5$claims;

      var auth = _this.props.auth;
      var firstName = ((auth === null || auth === void 0 ? void 0 : (_auth$state4 = auth.state) === null || _auth$state4 === void 0 ? void 0 : (_auth$state4$claims = _auth$state4.claims) === null || _auth$state4$claims === void 0 ? void 0 : _auth$state4$claims.given_name) || '')[0] || '';
      var lastName = ((auth === null || auth === void 0 ? void 0 : (_auth$state5 = auth.state) === null || _auth$state5 === void 0 ? void 0 : (_auth$state5$claims = _auth$state5.claims) === null || _auth$state5$claims === void 0 ? void 0 : _auth$state5$claims.family_name) || '')[0] || '';
      return "".concat(firstName).concat(lastName);
    });

    return _this;
  }

  _createClass(AppHeader, [{
    key: "render",
    value: function render() {
      var _auth$state6, _auth$state6$claims;

      var _this$props = this.props,
          auth = _this$props.auth,
          companyId = _this$props.companyId,
          onCompanyChange = _this$props.onCompanyChange;
      return /*#__PURE__*/React.createElement(Header, {
        className: "app-header"
      }, /*#__PURE__*/React.createElement(CompanySelect, {
        auth: auth,
        companyId: companyId,
        onChange: function onChange(company) {
          if (typeof onCompanyChange === 'function') {
            onCompanyChange(company);
          }
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "menu-bar"
      }, /*#__PURE__*/React.createElement(Popover, {
        trigger: "click",
        placement: "bottomRight",
        title: this.renderUserMenuTitle(),
        content: this.renderUserMenuContent()
      }, /*#__PURE__*/React.createElement(Avatar, {
        className: "app-header-avatar",
        src: auth === null || auth === void 0 ? void 0 : (_auth$state6 = auth.state) === null || _auth$state6 === void 0 ? void 0 : (_auth$state6$claims = _auth$state6.claims) === null || _auth$state6$claims === void 0 ? void 0 : _auth$state6$claims.picture
      }, this.getInitials()))));
    }
  }]);

  return AppHeader;
}(Component);

export default AppHeader;
//# sourceMappingURL=app-header.js.map